import { FormFieldV2 } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface OtherInfoTabProps {
  formMode: FormMode;
}

export const OtherInfoTab: React.FC<OtherInfoTabProps> = ({ formMode }) => {
  return (
    <div className='space-y-2 p-4'>
      <div className='space-y-1'>
        <div className='flex items-center'>
          <Label className='w-36 min-w-36'>Tên hiển thị</Label>
          <div className='flex flex-1 items-center gap-2'>
            <div className='flex-1'>
              <FormFieldV2
                type='text'
                placeholder='Tên dài gợi nhớ khi nhập liệu'
                name='ten_tknh'
                disabled={formMode === 'view'}
              />
            </div>
            <div className='flex-1'>
              <FormFieldV2 type='text' placeholder='Tên ngắn' name='sten_tknh' disabled={formMode === 'view'} />
            </div>
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-36 min-w-36'>Tỉnh thành</Label>
          <div className='w-full'>
            <FormFieldV2 type='text' name='tinh_thanh' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center gap-2'>
          <div className='flex items-center'>
            <Label className='w-36 min-w-36'>Điện thoại</Label>
            <FormFieldV2 type='text' name='phone' disabled={formMode === 'view'} />
          </div>

          <div className='flex items-center'>
            <Label className='w-20 min-w-20'>Fax</Label>
            <FormFieldV2 type='text' name='fax' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-36 min-w-36'>Ghi chú</Label>
          <div className='w-full'>
            <FormFieldV2 type='text' name='ghi_chu' disabled={formMode === 'view'} />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-36 min-w-36'>Trạng thái</Label>
          <div className='w-[250px]'>
            <FormFieldV2
              type='select'
              name='active'
              disabled={formMode === 'view'}
              options={[
                { value: true, label: '1. Còn sử dụng' },
                { value: false, label: '0. Không sử dụng' }
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
